import { render } from "./fileUploadComponent.vue?vue&type=template&id=ef73a320"
import script from "./fileUploadComponent.vue?vue&type=script&lang=js"
export * from "./fileUploadComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__